ACDiscountApp.PDPage.DisplayTiers = function () {

  function findMatchingTier(productType, productVendor, tierMatchArray) {
    if (!Array.isArray(tierMatchArray) || tierMatchArray.length === 0) {
        // Handle empty or non-array case
        return null;
    }

    for (const tier of tierMatchArray) {
        const tierData = tier.tier;
        const hasProductType = tierData.discountProductTypes.includes(productType);
        const hasProductVendor = tierData.discountVendorTypes.includes(productVendor);

        if (hasProductType && hasProductVendor) {
            return tierData;
        }
    }

    // If no match is found
    return null;
}
  this.DisplayTiersFn = function () {
   let productTypeAndVendorobj =  globalFields.productTypeAndVendor();
    // Example usage
    let productType = productTypeAndVendorobj.productType;
    let productVendor = productTypeAndVendorobj.productVendor;
    let tiermatch = productTypeAndVendorobj.memberTierObj;
    let matchedTier = findMatchingTier(productType, productVendor, tiermatch);
  if (matchedTier) {
    if(matchedTier.tier_status){
    jQuery('#anncodeMember').remove();
    let selectedVariantcheck = jQuery('input[name^=id]:checked, select[name^=id], input[name=id], hidden[name^=id]', jQuery('form[action="/cart/add"]')).val();
    let originalPriceoffProdutcnew = globalFields.priceChangeFunc(selectedVariantcheck);
    originalPriceoffProdutcnew = Number(originalPriceoffProdutcnew);
    let bundlewithVendorDiscount = Number(matchedTier.bundlewithVendorDiscount);
    let discount_type = matchedTier.discount_type;
    let discountedPrice = (originalPriceoffProdutcnew)-((originalPriceoffProdutcnew * bundlewithVendorDiscount) / 100);
    let originalPrice = globalFields.formatMoney(discountedPrice, globalFields.amount);
  jQuery('.product-meta__price-list-container').after(`<div class="price price--large" id="anncodeMember">Member Price : ${originalPrice}</div>`)
    }else{
      jQuery('#anncodeMember').remove();
      
    }
  } else {
      jQuery('#anncodeMember').remove();
  }
  
  
  }
  this.OnVariantChange = function () {
      setTimeout(function () {
          $(".select-wrapper combo-box").click(function () {
              displayTiers.DisplayTiersFn();
          });
      }, 2000);
  }
}

var globalFieldsProductPage_AC = new ACDiscountApp.PDPage.Global(), displayTiers = new ACDiscountApp.PDPage.DisplayTiers();
displayTiers.DisplayTiersFn();displayTiers.OnVariantChange();